<template>
  <div class="all">
      <div class="pc-normal-size">
          <div class="echart-grid bg-white">
              <div class="screen pb0 border-none clearfix">
                  <div class="item">
                      <div class="corm zu clearfix">
                          <span class="element cp" @click="selectHotTimeType(item.value,index)" :class="{curr:condition.type === item.value}" v-for="(item,index) in  hotTimeList" :key="index">{{item.name}}</span>
                      </div>
                      <span class="zu clearfix">
                          <span class="name">平台</span>
                          <drowDowns class="fl" v-model="condition.newsType" @confirmOption="selectPlatform">
                              <options v-for="(item,index) in platformList" :key="index" :label="item.newsType" :value="item.newsTypeId"></options>
                          </drowDowns>
                      </span>
                      <span class="zu clearfix">
                          <span class="name">数据分类</span>
                          <drowDowns class="fl" v-model="condition.tag" @confirmOption="selectPlatform">
                              <options v-for="(item,index) in tagList" :key="index" :label="item.tag" :value="item.tag"></options>
                          </drowDowns>
                      </span>
                      <span class="zu clearfix">
                          <span class="name">地区</span>
                          <citys @cityCallback="citySelect"></citys>
                      </span>
                      <span class="zu clearfix">
                          <span class="name">时间</span>
                          <vue-datepicker-local class="fl" v-model="time" show-buttons :disabledDate="disabledDate" clearable @clear="selectDate" @confirm="selectDate" placeholder="请选择时间"/>
                      </span>
                  </div>
              </div>
              <div class="row clearfix">
                  <!-- 数据汇总 -->
                  <div class="grid-father wh65">
                      <div class="grid h533">
                          <div class="no-data pt40" v-if="nodata.mapChartData"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                          <hotMapChart id="mapEchart" :dataArray="mapChartData" :areaName="curMapName" v-if="mapChartData != ''" :isShowTit='showTit'></hotMapChart>
                      </div>
                  </div>

                  <!-- 热点事件 -->
                  <div class="grid-father wh35">
                      <div class="grid h533">
                          <div class="grid-header clearfix">
                              <h2 class="title">{{hotTimeList[hotIndex].name}}事件TOP10</h2>
                          </div>
                          <div class="grid-body mt15">
                              <ul class="news">
                                  <li v-for="(item,index) in hotAllRank" :key="index" @click="item.newsIsRead = 1">
                                      <router-link class="cr3d" :to="{path:'eventDetail',query:{id:item.id,newsType:condition.newsType,type:condition.type}}" target="_blank">
                                          <span class="title ovhidden fl" :title="item.news_title" :style="{ color: item.newsIsRead ? $newsIsRead : '' }"><i class="order">{{index+1}}</i>{{item.news_title}}</span>
                                          <!-- <i class="icons fr mt15" :class="[{'icon-up':item.up>0},{'icon-down':item.up<0},{'icon-middle':item.up==0}]"></i> -->
                                          <strong class="data-num fr">{{item.exponent}}</strong>
                                      </router-link>
                                  </li>
                              </ul>
                              <div class="no-data no-datas" v-if="nodata.hotAllRank"><span class="text">没有数据哦...</span></div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="grid-data mt15 clearfix">
              <div class="grid fl bg-white clearfix hauto">
                  <div class="grid-header clearfix"><h2 class="title">全国数据</h2></div>
                  <div class="grid-body mt15" v-if="hotBotLeftList != ''">
                      <div class="imgText clearfix">
                          <router-link class="img fl" :to="{path:'eventDetail',query:{id:hotBotLeftList[0].id}}" target="_blank"><img :src="hotBotLeftList[0].picurl" onerror=""/></router-link>
                          <div class="hidden">
                              <h2 class="ovhidden2 mt20">
                                  <router-link class="cr3d fs16" :to="{path:'eventDetail',query:{id:hotBotLeftList[0].id}}" target="_blank">
                                      {{hotBotLeftList[0].news_title}}
                                  </router-link>
                              </h2>
                              <p class="time cr3d mt15 cr82"><i class="icons icon-time"></i>{{hotBotLeftList[0].publish_time}}</p>
                          </div>
                      </div>
                      <ul class="index-news mt15">
                          <li class="" v-for="(item,index) in hotBotLeftList" :key="index" v-if="index != 0">
                              <span class="bull fl">•</span>
                              <router-link class="title cr3d fl ovhidden" :to="{path:'eventDetail',query:{id:item.id}}" target="_blank">{{item.news_title}}</router-link>
                          </li>
                      </ul>
                  </div>
              </div>
              <div class="grid fr bg-white clearfix hauto">
                  <div class="grid-header clearfix">
                      <h2 class="title fl">{{hotCurCity}}数据</h2>
                      <span class="fr">
                          <citys @cityCallback="hotCitySelect"></citys>
                      </span>
                  </div>
                  <div class="grid-body mt15" v-if="hotBotRightList != ''">
                      <div class="imgText clearfix">
                          <router-link class="img fl" :to="{path:'eventDetail',query:{id:hotBotRightList[0].id}}" target="_blank"><img :src="hotBotRightList[0].picurl" onerror=""/></router-link>
                          <div class="hidden">
                              <h2 class="ovhidden2 mt20">
                                  <router-link class="cr3d fs16" :to="{path:'eventDetail',query:{id:hotBotRightList[0].id}}" target="_blank">
                                      {{hotBotRightList[0].news_title}}
                                  </router-link>
                              </h2>
                              <p class="time cr3d mt15 cr82"><i class="icons icon-time"></i>{{hotBotRightList[0].publish_time}}</p>
                          </div>
                      </div>
                      <ul class="index-news mt15">
                          <li class="" v-for="(item,index) in hotBotRightList" :key="index" v-if="index != 0">
                              <span class="bull fl">•</span>
                              <router-link class="title cr3d fl ovhidden" :to="{path:'eventDetail',query:{id:item.id}}" target="_blank">{{item.news_title}}</router-link>
                          </li>
                      </ul>
                  </div>
              </div>
          </div>
      </div>
</div>
</template>
<script>
import citys from '../../components/citys.vue'
import hotMapChart from '../../components/echart/hotMapChart.vue';
import VueDatepickerLocal from 'vue-datepicker-local'
export default {
  components:{citys,VueDatepickerLocal,hotMapChart},
  data() {
      return {
          mapChartData:'',
          curMapName:'全国',//当前城市地图
          showTit:true,
          platformList:[],//平台列表
          hotTimeList:[
              {name:'昨日热点',value:2},
              {name:'三日热点',value:3},
              {name:'七日热点',value:7}
          ],
    hotIndex:0,//选择热点时间的下标
          tagList:[],//数据分类
          condition:{
              type:2,
              newsType:'4',
              tag:'全部',
              date:'',
              province:'',
              city:'',
              country:''
          },
    hotCurCity:'',//当前选择的城市数据名称
          hotData:{
              type:1,
              province:'',
              city:'',
              country:''
          },//底部2个数据列表参数
          hotAllRank:[],
    time:'',
    nodata:{
      hotAllRank:false
          },
          hotBotLeftList:[],
          hotBotRightList:[],
      }
  },
  watch:{

  },
  mounted() {
      let that = this;
      that.newGetLocation();
  that.getSearchCondition();
      that.getHotRank();
      that.gethotData(0);
      that.getHotMapData();
  },
  created() {

  },
  methods: {
      // 定义获取城市方法
      newGetLocation() {
        this.$api.get("userCenter/index/get-location", null, r => {
          this.$utils.returnCode(r, () => {
            const res = r.data;
            console.log(res,111111111)
            let city = '北京市' // 获取城市信息
            let province = '北京市' // 获取省份信息
            if (res.province.fullName) province = res.province.fullName
            if (res.city.fullName) city = res.city.fullName
            this.hotData.province = province
            this.hotData.city = city
            this.hotCurCity = city
            this.gethotData(1)
          });
        });
      },
      //定义获取城市方法
      getLocation(){
          const geolocation = new BMap.Geolocation();
          var that = this;
          geolocation.getCurrentPosition(function getinfo(position){
              let city = position.address.city;             //获取城市信息
              let province = position.address.province;    //获取省份信息
              that.hotData.province = province
              that.hotData.city = city
      that.hotCurCity = city;
              that.gethotData(1);
          }, function(e) {
              that.hotData.province = '北京市'
              that.hotData.city = '北京市'
              that.gethotData(1);
          }, {provider: 'baidu'});
      },
      // 获取筛选条件
      getSearchCondition (){
          let that = this;
    that.$api.get('hotnews/index/search-condition',null,r=>{
        that.$utils.returnCode(r,function(){
                  that.platformList = r.data.newsTypeList;
                  that.tagList = r.data.tagList;
        });
    });
      },
      // 获取区域热度数据
      getHotMapData (){
          let that = this;
          // let country = that.condition.country;
          // if(country){
          //     return;
          // }
    that.$api.get('hotnews/index/hot-list-map',that.condition,r=>{
        that.$utils.returnCode(r,function(){
            that.mapChartData = r.data.list;
        });
    });
      },
      getHotRank (){
    let that = this;
    that.$api.get('hotnews/index/hot-top-ten',that.condition,r=>{
        that.$utils.returnCode(r,function(){
            if(r.data.list.length<=0){
                that.nodata.hotAllRank = true;
            }else{
                that.nodata.hotAllRank = false;
            }
            r.data.list.forEach(it=>it.newsIsRead = 0)
            that.hotAllRank = r.data.list;

        },function(){
                  that.hotAllRank = [];
                  that.hotBotLeftList = [];
                  that.hotBotRightList = [];
              });
    });
      },
      // 选择平台
      selectPlatform (type){
          this.getHotRank();
          this.getHotMapData();
      },
      // 选择地区
      fatherMethod (name,type){
          if(type === 1){//选择的是省级
              this.condition.province = name;
          }else if(type === 2){//选择的是市级
              this.condition.city = name;
          }else if(type === 3){//选择的是区级
              this.condition.country = name;
          }
          this.curMapName = name
          this.selectPlatform();
      },
      // 热点时间选择
      selectHotTimeType (value,index){
          this.condition.type = value;
    this.hotIndex = index;
          this.selectPlatform();
      },
      // 地区筛选
      citySelect (value) {
          if(value[0] === '全国'){
              this.condition.province = '';
              this.condition.city = '';
              this.condition.country = '';
              this.fatherMethod();
              this.curMapName = '全国';
          }else if(value[1] === '全省' || value[1] === ''){
              this.condition.province = value[0];
              this.condition.city = '';
              this.condition.country = '';
              this.fatherMethod(value[0],1);
              this.curMapName = value[0];
          }else if(value[4] === '全市'){
              this.condition.province = value[0];
              this.condition.city = value[1];
              this.condition.country = '';
              this.fatherMethod(value[1],2);
              this.curMapName = value[1];
          }else{
              this.condition.province = value[0];
              this.condition.city = value[1];
              this.condition.country = value[4];
              this.curMapName = value[1];
              this.fatherMethod(value[4],3);
          }

        console.log(this.curMapName, 'curMapName')
          this.selectPlatform();
      },
      // 热点数据城市选择
      hotCitySelect (value){
          if(value[0] === '全国'){
      this.hotCurCity = '全国';
              this.hotData.province = '';
              this.hotData.city = '';
              this.hotData.country = '';
          }else if(value[1] === '全省'){
      this.hotCurCity = value[0];
              this.hotData.province = value[0];
              this.hotData.city = '';
              this.hotData.country = '';
          }else if(value[4] === '全市'){
      if(value[1] === ''){
        this.hotCurCity = value[0];
      }else{
        this.hotCurCity = value[1];
      }
              this.hotData.province = value[0];
              this.hotData.city = value[1];
              this.hotData.country = '';
          }else{
      this.hotCurCity = value[4];
              this.hotData.province = value[0];
              this.hotData.city = value[1];
              this.hotData.country = value[4];
          }
          this.gethotData(1);
      },
      // 选择时间
      selectDate (){
          if(this.time === ''){
              this.time = new Date();
          }
          this.condition.date = this.$utils.dateConversion(this.time,0);
          this.selectPlatform();
      },
  // 禁止时间
  disabledDate (time){
    let nowTime = this.$utils.getNowDate();//今天时间
    return time.getTime() > this.$utils.dateToMillisecond(nowTime);
      },
      // 获取全国数据
      gethotData (type){
          let that = this;
          let data;
          if(type === 0){//全国数据
              data = {
                  type:1,
                  province:'',
                  city:'',
                  country:''
              }
          }else{
              data = that.hotData;
          }
    that.$api.get('hotnews/index/hot-list',data,r=>{
        that.$utils.returnCode(r,function(){
                  if(type === 0){
                      that.hotBotLeftList = r.data.list;
                  }else{
                      that.hotBotRightList = r.data.list;
                  }
        });
    });
      }
}
}
</script>



// WEBPACK FOOTER //
// src/page/hotSpotEvents/eventsIndex.vue